"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var md_1 = require("react-icons/md");
var Radio = function (_a) {
    var style = _a.style, className = _a.className, label = _a.label, checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { style: style, className: classNames(styles.radio, className, disabled && styles.disabled) },
        React.createElement("label", { className: styles.inner },
            React.createElement("input", { type: "radio", className: styles.input, checked: checked, disabled: disabled, onChange: function (e) {
                    if (!disabled && onChange) {
                        onChange(e.currentTarget.checked);
                    }
                } }),
            React.createElement("p", { className: styles.shape },
                React.createElement(md_1.MdRadioButtonChecked, { className: classNames(styles.icon, styles.checked) }),
                React.createElement(md_1.MdRadioButtonUnchecked, { className: classNames(styles.icon, styles.unchecked) })),
            label && React.createElement("p", { className: styles.label }, label))));
};
exports.default = Radio;
